import React from 'react';

import StudioShell from './components/StudioShell';
import { useSelfStudioData } from './live/useSelfStudioData';
import './studio2.css';

/**
 * Per-player ("self") entry point for the Analysis Studio, rendered inside
 * TraineeSession. Same shared `StudioShell` as the trainer view, but in 'self'
 * mode: a single player (the authenticated trainee), no Rail / Leaderboard /
 * online count / rank, the anonymised cohort scatter, and no group report. Data
 * comes from `useSelfStudioData`, every fetch of which is scoped to the
 * requester server-side.
 */
const AnalysisStudioSelf: React.FC = () => {
  const {
    players,
    session,
    groupReports,
    isReady,
    scatterPoints,
    relativizeDate,
  } = useSelfStudioData();
  const selfId = players[0]?.id ?? -1;

  return (
    <StudioShell
      mode="self"
      players={players}
      session={session}
      groupReports={groupReports}
      isReady={isReady}
      scatterPoints={scatterPoints}
      relativizeDate={relativizeDate}
      selectedId={selfId}
      onSelect={() => {}}
    />
  );
};

export default AnalysisStudioSelf;
